import { useState } from 'react';
import { setReconcileDate as setReconcileDateApi } from '../api/commissions';

/**
 * Hook for setting the reconcile date on an estimator's account
 * This "freezes" the account - commissions before this date are considered settled
 */
export function useSetReconcileDate() {
  const [isLoading, setIsLoading] = useState(false);

  const setReconcileDate = async (
    userId: number,
    reconcileDate: string
  ): Promise<boolean> => {
    setIsLoading(true);
    try {
      await setReconcileDateApi(userId, reconcileDate);
      return true;
    } catch (error) {
      console.error('Set reconcile date error:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { setReconcileDate, isLoading };
}
